module.exports = __webpack_public_path__ + "assets/fonts/fontawesome-webfont.ttf";